import { heightAtLatLng, highResMarkers } from "../../utils/mapping-functions";
import SETTINGS from "../../settings";
import log from "loglevel";

const BoundaryWall = (props) => {
  let boundaryWall = [];
  const heightMap = props.heightMap;
  const sitePlanCoords = props.sitePlanCoords;
  const size = heightMap.boundBox.size;
  const min = heightMap.heightLimits.min;
  const scale = SETTINGS.TERRAIN.SCALE;

  if (sitePlanCoords.length > 0) {
    const highresBoundary = highResMarkers(sitePlanCoords);
    for (let i = 0; i < highresBoundary.length; i++) {
      const point = heightAtLatLng(highresBoundary[i], heightMap);
      boundaryWall.push(
        new THREE.Vector3(
          (point.x * size.x - size.x / 2) / scale,
          (point.z - min) / scale,
          (point.y * size.y - size.y / 2) / scale
        )
      );
    }
  }

  return (
    <group>
      <line position={[0, 2 / scale, 0]}>
        <geometry
          attach="geometry"
          vertices={boundaryWall}
          onUpdate={(self) => (self.verticesNeedUpdate = true)}
        />
        <lineBasicMaterial
          attach="material"
          emissive={0xff6666}
          color={0xff0000}
        />
      </line>
    </group>
  );
};

export default React.memo(BoundaryWall);
